export * from './actionTypes';
export * from './moduleName';

export const INTERCOM_LAUNCHER_LINK_CLASS = 'open_intercom_widget';
export const INTERCOM_REQUEST_OFFER_CLASS = 'request-offer-intercom-selector';
export const INTERCOM_REQUEST_MIX_CANCELLATION_CLASS = 'request-mix-cancellation-intercom-button';
export const INTERCOM_CONTACT_SALES_CLASS = 'contact-sales-intercom-selector';
export const INTERCOM_REQUEST_PURCHASE_CONTACT_SALES_CLASS =
    'request-purchase-contact-sales-intercom-selector';
